import ParentingView from './ParentingView'

export default ParentingView
